import React, { useEffect } from 'react';
import './styles.css';
import handleBackEvent from '../../utils/goBack';

function Navbar({ heading, children }) {

  return (
    <div className="Navbar">
      <div className="Navbar__Left">
        
        <div className="Navbar__Left--Heading">{heading}</div>
      </div>
      <div className="Navbar__Right">{children}</div>
    </div>
  );
}

export default Navbar;
